import { FunctionComponent } from "react";
import "./styles/EnrolmentForm.scss";

import { Input } from "./core/Input";
import { IEnrolmentFormData } from "../models/EnrolmentFormData";
import dayjs from "dayjs";
import { SCREEN_SIZE } from "../models";
import { classNames } from "../utils";

interface IEnrolmentFormProps {
  formData: IEnrolmentFormData;
  formDataChanged: (form: IEnrolmentFormData) => void;
  screenSize: SCREEN_SIZE;
  disabled?: boolean;
}
export const EnrolmentForm: FunctionComponent<IEnrolmentFormProps> = (props: IEnrolmentFormProps) => {
  const { formData, formDataChanged, screenSize, disabled } = props;

  const handleFormInputChanged = (
    newValue: string,
    field: keyof IEnrolmentFormData
  ) => {
    const updatedFormData = {
      ...formData,
      [field]: newValue,
    };
    formDataChanged(updatedFormData);
  };

  return (
    <div className={classNames('ppa-schedule-enrolment-form', screenSize)}>
      <div className="form-section">
        <h2>Parent Details</h2>

        <div className="form-section-fields-wrapper">
          <Input
            value={formData.parentFirstName}
            onChange={(x) => handleFormInputChanged(x, "parentFirstName")}
            name="parentFirstName"
            label="First Name"
            type="text"
            required
            disabled={disabled}
            maxLength={50}
          />
          <Input
            value={formData.parentLastName}
            onChange={(x) => handleFormInputChanged(x, "parentLastName")}
            name="parentLastName"
            label="Last Name"
            type="text"
            required
            disabled={disabled}
            maxLength={80}
          />
        </div>

        <div className="form-section-fields-wrapper">
          <Input
            value={formData.contactPhoneNumber}
            onChange={(x) => handleFormInputChanged(x, "contactPhoneNumber")}
            name="contactPhoneNumber"
            label="Contact Phone Number"
            type="tel"
            required
            disabled={disabled}
          />
          <Input
            value={formData.contactEmail}
            onChange={(x) => handleFormInputChanged(x, "contactEmail")}
            name="contactEmail"
            label="Contact Email"
            type="email"
            maxLength={150}
            required
            disabled={disabled}
          />
        </div>
      </div>

      <div className="form-section">
        <h2>Student Details</h2>

        <div className="form-section-fields-wrapper">
          <Input
            value={formData.studentFirstName}
            onChange={(x) => handleFormInputChanged(x, "studentFirstName")}
            name="studentFirstName"
            label="First Name"
            type="text"
            required
            disabled={disabled}
            maxLength={50}
          />
          <Input
            value={formData.studentLastName}
            onChange={(x) => handleFormInputChanged(x, "studentLastName")}
            name="studentLastName"
            label="Last Name"
            type="text"
            required
            disabled={disabled}
            maxLength={80}
          />
        </div>

        <div className="form-section-fields-wrapper">
          <Input
            value={formData.studentDateOfBirth}
            onChange={(x) => handleFormInputChanged(x, "studentDateOfBirth")}
            name="studentDateOfBirth"
            label="Date of Birth"
            type="date"
            required
            disabled={disabled}
            max={dayjs().subtract(1, 'day').format('YYYY-MM-DD')}
            min="1920-01-01"
          />
          <Input
            value={formData.medicalRequirements}
            onChange={(x) => handleFormInputChanged(x, "medicalRequirements")}
            name="medicalRequirements"
            label="Medical Requirements / Allergies"
            type="textarea"
            rows={4}
            disabled={disabled}
            maxLength={200}
          />
        </div>
      </div>
    </div>
  );
};
